import React, {Component} from 'react';
import {Icon, Table} from "antd";
import {connect} from 'react-redux'
import {injectIntl} from "react-intl";
import PropTypes from 'prop-types';
import InterventionStatus from "../../common/format/InterventionStatus";
import JourneyType from "../../common/format/JourneyType";
import MessageStatus from "../../common/format/MessageStatus";
import {isOnAlert} from "../../../services/Tasks";
import Constants from "../../../services/Constants";
import InterventionType from "../../intervention/InterventionType";
import InterventionDate from "../../common/format/InterventionDate";
import InterventionCustomer from "../../common/format/InterventionCustomer";
import InterventionVehicle from "../../common/format/InterventionVehicle";

import "./TasksTable.css";
import {withRouter} from "react-router-dom";
import Intervention from "../../../services/Intervention";
import User from "../../../services/User";
import DateFormat from "../../common/format/DateFormat";
import {getDealersIdsAndName} from "../../../selectors/dealers";
import {fetchDealers} from "../../../actions/dealersActions";
import FilterDate from "./filter/FilterDate";
import FilterCheckbox from "./filter/FilterCheckbox";
import Storage from "../../../services/Storage";
import {LOCATION_KEY, PREVIOUS_LOCATION, SCROLL_POSITION} from "../../../constants/storageKeys";

const Column = Table.Column;

class TasksTable extends Component {

  componentDidMount() {
    if (!User.isCallCenterAgent()) {
      this.props.dispatchFetchAdvisors();
    } else {
      this.props.dispatchFetchDealers();
    }
  }

  parseDealersToFilterLabel = (dealers) => {
    if (!dealers) {
      return [{label: '', value: ''}];
    }
    return dealers.map(dealer => ({label: dealer.dealerName, value: dealer.id}));
  };

  parseAdvisorsToFilterLabel = (distinctAdvisors) => {
    if (!distinctAdvisors) {
      return [{labe: '', value: ''}];
    }
    return distinctAdvisors.map(advisor => ({label: advisor, value: advisor}));
  };

  persistScrollPositionAndLocation = () => {
    const {location} = this.props;
    Storage.setSessionItem(SCROLL_POSITION, window.scrollY);
    if (location.key) {
      Storage.setSessionItem(LOCATION_KEY, location.key);
    } else {
      Storage.setSessionItem(PREVIOUS_LOCATION, location.pathname);
    }
  };

  render() {
    const {interventions, loading} = this.props.fetchInterventions;
    const {distinctAdvisors} = this.props.fetchDistinctAdvisors;
    const {intl: {formatMessage}, contentUpdater, dealers, showArchived} = this.props;

    return (
      <div className="table-wrapper__body">
        <Table className="table overview-table"
               dataSource={interventions.content}
               loading={loading}
               rowKey={'interventionId'}
               pagination={false}         // pagination handled manually
               rowClassName={(record) => {
                 const startDate = new Date(record.interventionStart);
                 const endDate = new Date(record.interventionEnd);

                 if (Intervention.requiresRedFlag(record) || isOnAlert(startDate, endDate, record.interventionStatus, record.type)) {
                   return "is-on-alert";
                 }
                 return null;
               }}
               onRow={(record) => {
                 return {
                   onClick: () => {
                     this.persistScrollPositionAndLocation();
                     !User.isCallCenterAgent() && this.props.history.push(`/interventions/${record.interventionId}`)
                   }
                 };
               }}
        >
          {User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'menu.dealership'})}
            dataIndex="dealerName"
            key="dealerName"
            className="overview-table__dealerName"
            filterDropdown={(filter) => <FilterCheckbox apiKey={'dealerId'} contentUpdater={contentUpdater}
                                                        options={this.parseDealersToFilterLabel(dealers)}
                                                        filter={filter}/>}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
          />}
          {User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'tasksTable.createdOn'})}
            dataIndex="createdOn"
            key="createOn"
            className="overview-table__createdOn"
            render={(text) => <DateFormat date={text} layout="dateOnly"/>}
            filterDropdown={(filter) => <FilterDate apiKeyStart={'createdOnFrom'} apiKeyEnd={'createdOnTo'}
                                                    contentUpdater={contentUpdater} filter={filter}/>}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
          />}
          {!User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'tasksTable.status'})}
            dataIndex="interventionStatus"
            key="status"
            className="overview-table__status"
            filterDropdown={(filter) => {
              const statusFilterOptions = Constants.STATUS_FILTER.map(status => ({
                label: formatMessage(status.label),
                value: status.value
              }));
              if (showArchived) {
                statusFilterOptions.push({
                  label: formatMessage(Constants.STATUS_ARCHIVED.label),
                  value: Constants.STATUS_ARCHIVED.value
                });
              }
              return <FilterCheckbox apiKey={'interventionStatus'} contentUpdater={contentUpdater}
                                     options={statusFilterOptions} filter={filter}/>;
            }}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
            render={(text, record) => <InterventionStatus status={text}
                                                          previousStatus={record.interventionPreviousStatus}/>}
          />}
          {!User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'tasksTable.createdOn'})}
            dataIndex="createdOn"
            key="createOn"
            className="overview-table__createdOn"
            render={(text) => <DateFormat date={text} layout="dateTimeShort"/>}
            filterDropdown={(filter) => <FilterDate apiKeyStart={'createdOnFrom'} apiKeyEnd={'createdOnTo'}
                                                    contentUpdater={contentUpdater} filter={filter}/>}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
          />}
          <Column
            title={formatMessage({id: 'tasksTable.dates'})}
            dataIndex="interventionDate"
            key="dates"
            className="overview-table__dates"
            filterDropdown={(filter) => <FilterDate apiKeyStart={'interventionStart'} apiKeyEnd={'interventionEnd'}
                                                    contentUpdater={contentUpdater} filter={filter}/>}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
            render={(_, record) => <InterventionDate interventionStart={record.interventionStart}
                                                     interventionEnd={record.interventionEnd}
                                                     properties={record.properties}/>}
          />
          <Column
            title={formatMessage({id: 'tasksTable.customerCar'})}
            dataIndex="customerCar"
            key="customerCar"
            className="overview-table__customer-car"
            filterDropdown={(filter) => {
              const brandFilterOptions = Constants.BRANDS.map(status => ({
                label: formatMessage(status.label),
                value: status.value
              }));
              return <FilterCheckbox apiKey={'carBrand'} contentUpdater={contentUpdater}
                                     options={brandFilterOptions} filter={filter}/>;
            }}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
            render={(_, record) => <InterventionCustomer firstName={record.customerFirstname}
                                                         lastName={record.customerLastname} carBrand={record.carBrand}
                                                         carModel={record.carModel}/>}
          />
          <Column
            title={formatMessage({id: 'vehicle.vin'}) + ' & ' + formatMessage({id: 'vehicle.plate'})}
            dataIndex="vinPlate"
            key="vinPlate"
            className="overview-table__vin-plate"
            render={(_, record) => <InterventionVehicle carVin={record.carVin} carPlate={record.carPlate}/>}
          />
          {!User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'tasksTable.advisor'})}
            dataIndex="advisor"
            key="advisor"
            className="overview-table__advisor"
            filterDropdown={(filter) => <FilterCheckbox apiKey={'advisor'}
                                                        options={this.parseAdvisorsToFilterLabel(distinctAdvisors.body)}
                                                        contentUpdater={contentUpdater} filter={filter} emptyValueFilter />}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
          />}
          <Column
            title={formatMessage({id: 'tasksTable.type'})}
            dataIndex="type"
            key="type"
            className="overview-table__type"
            filterDropdown={(filter) => {
              const typeFilterOptions = Constants.TYPES.map(status => ({
                label: formatMessage(status.label),
                value: status.value
              }));
              return <FilterCheckbox apiKey={'type'} options={typeFilterOptions}
                                     contentUpdater={contentUpdater} filter={filter}/>
            }}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
            render={text => <JourneyType type={text}/>}
          />
          {!User.isCallCenterAgent() && <Column
            title={formatMessage({id: 'tasksTable.origin'})}
            dataIndex="origin"
            key="origin"
            className="overview-table__type"
            filterDropdown={(filter) => {
              const originFilterOptions = Constants.ORIGINS.map(status => ({
                label: formatMessage(status.label),
                value: status.value
              }));
              return <FilterCheckbox apiKey={'origins'} options={originFilterOptions}
                                     contentUpdater={contentUpdater} filter={filter}/>
            }}
            filterIcon={filtered => <Icon type="filter" theme={filtered ? "filled" : "outlined"}/>}
            render={(text, intervention) => {
              return formatMessage({id: `intervention.origin.${Intervention.getDisplayOrigin(text, intervention.carBrand)}`})
            }}
          />}
          <Column
            title=""
            dataIndex="properties"
            key="properties"
            className="overview-table__fl-247 txtcenter"
            render={(properties, record) => {
              return <React.Fragment>
                <InterventionType journey={{properties}} fleetback={record.fleetbackIntervention}/>
              </React.Fragment>
            }
            }
          />
          {!User.isCallCenterAgent() && <Column
            title=""
            dataIndex="lastMessageHandled"
            key="messageStatus"
            className="overview-table__messages txtcenter"
            render={lastMessageHandled => <MessageStatus isActive={!lastMessageHandled}/>}
          />}
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInterventions: state.fetchInterventions,
  fetchDistinctAdvisors: state.fetchDistinctAdvisors,
  dealers: getDealersIdsAndName(state)
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchAdvisors: () => dispatch({type: 'FETCH_DISTINCT_ADVISORS.REQUEST'}),
  dispatchFetchDealers: () => dispatch(fetchDealers())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(TasksTable)));

TasksTable.propTypes = {
  content: PropTypes.array,
  loading: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/overview/table/TasksTable.js